exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-31622ae0] .required label.v-label.theme--light:before {\n  content: \"*\";\n  color: red;\n}", ""]);

// exports
